import type {
  Response,
  EmailNotificationResponse,
} from '@/lib/apollo/query/getEmailNotifications/query'
import { parseDate } from '@/utils/date'

import type { TransformedData, TransformedEmailNotificationData } from './types'

export const toTransformedEmailNotificationData = (
  notification: EmailNotificationResponse,
): TransformedEmailNotificationData => ({
  ...notification,
  sentDate: parseDate(notification.sentDate),
})

export const toTransformedData = (response?: Response): TransformedData | undefined =>
  response === undefined
    ? undefined
    : {
        ...response.getEmailNotifications,
        results: response.getEmailNotifications.results.map(
          toTransformedEmailNotificationData,
        ),
      }
